/**
 * Croatian Translations — Impact Core i18n
 *
 * Flat key-value structure. Keys use dot notation for namespacing.
 * Coverage: navigation, actions, statuses, dashboard labels, form labels.
 */

export const hr: Record<string, string> = {
  // Navigation
  'nav.dashboard': 'Nadzorna ploča',
  'nav.funds': 'Fondovi',
  'nav.investments': 'Ulaganja',
  'nav.investees': 'Primatelji ulaganja',
  'nav.esg': 'ESG Pregled',
  'nav.compliance': 'Usklađenost',
  'nav.reports': 'Izvješća',
  'nav.settings': 'Postavke',
  'nav.users': 'Korisnici',
  'nav.sfdr': 'SFDR',
  'nav.pai': 'PAI Pokazatelji',
  'nav.taxonomy': 'EU Taksonomija',
  'nav.filings': 'Podnesci',
  'nav.calendar': 'Kalendar',
  'nav.submit': 'Podnošenje podataka',
  'nav.submissions': 'Moji podnesci',
  'nav.benchmarks': 'Referentne vrijednosti',
  'nav.messages': 'Poruke',
  'nav.portfolio': 'Portfelj',
  'nav.performance': 'Uspješnost fondova',
  'nav.esgSummary': 'ESG Sažetak',
  'nav.pipeline': 'Kanal',
  'nav.dueDiligence': 'Dubinska analiza',
  'nav.impact': 'Pokazatelji utjecaja',
  'nav.sdg': 'Mapiranje COR-ova',
  'nav.audit': 'Revizijski trag',
  'nav.snapshots': 'Snimke podataka',
  'nav.knowledgeGraph': 'Graf znanja',
  'nav.geographic': 'Geografski',
  'nav.bi': 'BI Studio',
  'nav.ai': 'AI Asistent',
  'nav.tasks': 'Zadaci',
  'nav.csrd': 'CSRD',
  'nav.regulatory': 'Regulatorni monitor',

  // Common Actions
  'action.create': 'Stvori',
  'action.edit': 'Uredi',
  'action.delete': 'Obriši',
  'action.save': 'Spremi',
  'action.cancel': 'Odustani',
  'action.submit': 'Podnesi',
  'action.approve': 'Odobri',
  'action.reject': 'Odbij',
  'action.download': 'Preuzmi',
  'action.export': 'Izvezi',
  'action.import': 'Uvezi',
  'action.filter': 'Filtriraj',
  'action.search': 'Pretraži',
  'action.refresh': 'Osvježi',
  'action.close': 'Zatvori',
  'action.back': 'Natrag',
  'action.next': 'Sljedeće',
  'action.previous': 'Prethodno',
  'action.viewAll': 'Prikaži sve',
  'action.viewDetails': 'Prikaži detalje',
  'action.generate': 'Generiraj',
  'action.signOut': 'Odjava',
  'action.addNew': 'Dodaj novo',
  'action.invite': 'Pozovi',

  // Statuses
  'status.draft': 'Nacrt',
  'status.submitted': 'Podneseno',
  'status.validated': 'Validirano',
  'status.approved': 'Odobreno',
  'status.rejected': 'Odbijeno',
  'status.pending': 'Na čekanju',
  'status.inProgress': 'U tijeku',
  'status.overdue': 'Zakašnjelo',
  'status.compliant': 'Usklađeno',
  'status.filed': 'Podneseno',
  'status.active': 'Aktivno',
  'status.inactive': 'Neaktivno',
  'status.closed': 'Zatvoreno',
  'status.fundraising': 'Prikupljanje sredstava',
  'status.investing': 'Ulaganje',
  'status.harvesting': 'Žetva',

  // Dashboard Labels
  'dashboard.portfolioOverview': 'Pregled portfelja',
  'dashboard.complianceStatus': 'Status usklađenosti',
  'dashboard.collectionProgress': 'Napredak prikupljanja',
  'dashboard.activityFeed': 'Aktivnost',
  'dashboard.quickActions': 'Brze radnje',
  'dashboard.investmentPipeline': 'Investicijski kanal',
  'dashboard.totalFunds': 'Ukupno fondova',
  'dashboard.aum': 'AUM',
  'dashboard.activeInvestments': 'Aktivna ulaganja',
  'dashboard.totalInvestees': 'Primatelji ulaganja',
  'dashboard.recentActivity': 'Nedavna aktivnost',

  // LP Dashboard Labels
  'lp.totalCommitted': 'Ukupno obvezano',
  'lp.capitalCalled': 'Pozvani kapital',
  'lp.distributed': 'Distribuirano',
  'lp.netPosition': 'Neto pozicija',
  'lp.tvpi': 'TVPI',
  'lp.dpi': 'DPI',
  'lp.fundPerformance': 'Uspješnost fondova',
  'lp.esgSummary': 'ESG Sažetak',
  'lp.reportLibrary': 'Knjižnica izvješća',
  'lp.taxonomyAligned': 'Usklađeno s taksonomijom',
  'lp.paiCoverage': 'PAI Pokrivenost',
  'lp.portfolioPerformance': 'Uspješnost LP portfelja',

  // Fund Labels
  'fund.name': 'Naziv fonda',
  'fund.code': 'Šifra fonda',
  'fund.vintage': 'Godina osnivanja',
  'fund.size': 'Veličina fonda',
  'fund.targetSize': 'Ciljna veličina',
  'fund.currency': 'Valuta',
  'fund.strategy': 'Strategija',
  'fund.status': 'Status',
  'fund.sfdrCategory': 'SFDR Kategorija',
  'fund.geographyFocus': 'Geografski fokus',
  'fund.sectorFocus': 'Sektorski fokus',

  // Form Labels
  'form.name': 'Naziv',
  'form.email': 'E-pošta',
  'form.country': 'Država',
  'form.amount': 'Iznos',
  'form.currency': 'Valuta',
  'form.date': 'Datum',
  'form.description': 'Opis',
  'form.notes': 'Bilješke',
  'form.type': 'Vrsta',
  'form.period': 'Razdoblje',
  'form.year': 'Godina',
  'form.required': 'Obavezno',
  'form.optional': 'Neobavezno',

  // Table Headers
  'table.fund': 'Fond',
  'table.commitment': 'Obveza',
  'table.called': 'Pozvano',
  'table.distributed': 'Distribuirano',
  'table.tvpi': 'TVPI',
  'table.status': 'Status',
  'table.regulation': 'Regulativa',
  'table.filingType': 'Vrsta podneska',
  'table.reportingPeriod': 'Razdoblje',
  'table.createdAt': 'Stvoreno',
  'table.actions': 'Radnje',

  // Compliance
  'compliance.sfdr': 'SFDR',
  'compliance.taxonomy': 'EU Taksonomija',
  'compliance.pai': 'PAI',
  'compliance.dataCompleteness': 'Potpunost podataka',
  'compliance.nextDeadline': 'Sljedeći rok',

  // Reports
  'report.quarterly': 'Tromjesečno izvješće',
  'report.annual': 'Godišnje izvješće',
  'report.paiStatement': 'PAI Izjava',
  'report.taxonomyReport': 'Izvješće o taksonomiji',
  'report.generatedAt': 'Generirano',
  'report.version': 'Verzija',

  // General
  'general.loading': 'Učitavanje...',
  'general.noData': 'Nema dostupnih podataka',
  'general.error': 'Došlo je do pogreške',
  'general.retry': 'Pokušaj ponovno',
  'general.total': 'Ukupno',
  'general.page': 'Stranica',
  'general.of': 'od',
  'general.showing': 'Prikaz',
  'general.results': 'rezultata',
  'general.language': 'Jezik',
  'general.english': 'Engleski',
  'general.french': 'Francuski',

  // Tour
  'tour.takeTour': 'Pokrenite obilazak',
  'tour.skip': 'Preskoči',
  'tour.next': 'Sljedeće',
  'tour.prev': 'Prethodno',
  'tour.finish': 'Završi',
};
